module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/681994a7b229e8390f9ae5e94312ea1a.png";